import React from 'react';
import styles from './styles.scss';
import LodIcon from 'components/util/lodIcon';
import classnames from 'classnames';

export function ClassicButton(props) {
  const center = !props.iconLeft && !props.iconRight;
  const { disabled } = props;

  return (
    <div
      className={classnames(styles.classicBtn, {
        [styles.success]: props.success,
        [styles.outline]: props.outline,
        [styles.center]: center,
        [styles.disabled]: disabled
      })}
      style={props.style}
      onClick={disabled ? null : props.onClick}>
      {!!props.iconLeft && (
        <LodIcon
          icon={props.iconLeft}
          className={classnames(styles.icon, styles.iconLeft)}
        />
      )}
      <span className={styles.label}>{props.label}</span>
      {!!props.iconRight && (
        <LodIcon
          icon={props.iconRight}
          className={classnames(styles.icon, styles.iconRight)}
        />
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/util/buttons/index.js